import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import type { PartnerUser } from './createPartnerUser';

export const associateAsPartnerUser = async (codeName: string, email: string): Promise<PartnerUser> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation AssociateAsPartnerUser($codeName: String!, $email: String!) {
        associateAsPartnerUser(codeName: $codeName, email: $email) {
          id
          firstName
          lastName
          email
          highestRole
          isActive
        }
      }
    `),
    variables: {
      codeName,
      email,
    },
  });

  return response.data!.associateAsPartnerUser;
};
